import { findLast } from 'lodash';
import { createStore, createActionsHook, createStateHook } from 'react-sweet-state';
import type { HelpseekerMessage, Message } from '../../common/types';
import { addMessage, selectOption, clearConversation } from './actions';
import { ConversationStateContainer } from './container';
import type { State } from './types';

const initialState: State = {
    conversationProvider: {
        sendMessage: () => Promise.reject(new Error('No conversation provider')),
        startConversation: () => Promise.reject(new Error('No conversation provider')),
    },
    messages: [],
};

const store = createStore({
    initialState,
    name: 'Conversation',
    actions: {
        addMessage,
        selectOption,
        clearConversation,
    },
    containedBy: ConversationStateContainer,
    handlers: {
        onInit:
            () =>
            ({ setState }, { conversationProvider }) => {
                setState({ conversationProvider });
            },
        onUpdate:
            () =>
            ({ setState }, { conversationProvider }) => {
                setState({ conversationProvider });
            },
    },
});

export const useMessages = createStateHook(store, {
    selector: (state) => state.messages,
});

export const useIsLoading = createStateHook(store, {
    selector: (state) => state.isLoading,
});

export const useAppendices = createStateHook(store, {
    selector: (state) => {
        const [lastMessage] = state.messages.slice(-1);
        if (lastMessage?.message.authorType === 'AGENT') {
            return lastMessage.message.appendices;
        }
        return undefined;
    },
});

export const useLastHelpseekerMessage = createStateHook(store, {
    selector: (state) =>
        findLast(
            state.messages,
            (message: Message) => message.message.authorType === 'HELPSEEKER'
        ) as HelpseekerMessage,
});

export const useLastMessage = createStateHook(store, {
    selector: (state) => findLast(state.messages),
});

export const useConversationHasMessages = createStateHook(store, {
    selector: (state) => state.messages.length > 0,
});

export const useActions = createActionsHook(store);
